import WorkIcon from '@mui/icons-material/Work';
import { Stack, Typography } from '@mui/material';
import { AnalysisSelectionNew } from 'enums';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';
import { ProfileValues } from 'types/profile.types';
import ContactPersona from '../contact-analysis-results/contact-persona';
import AnalysisTabBar from '../contact-analysis-results/analysis-tab-bar';
import AnalysisTabContent from '../contact-analysis-results/analysis-tab-content';

// interface Criterion {
//   name: string;
//   values: { text: string; isFulfilled: boolean }[];
// }

// interface Criteria {
//   critical: Criterion[];
//   important: Criterion[];
//   other: Criterion[];
// }

// const CriterionItem: React.FC<{ criterion: Criterion; isLast: boolean }> = ({ criterion, isLast }) => {
//   const { classes, cx } = useStyles();

//   return (
//     <Stack direction={'row'}>
//       <div className={cx(classes.criterionName, isLast ? 'is-last' : undefined)}>
//         <Typography className={classes.greyText}>{criterion.name}</Typography>
//       </div>
//       <Stack sx={{ flex: 1 }}>
//         {criterion.values.map((item, index) => (
//           <Stack
//             key={index}
//             className={cx(classes.criterionValue, isLast ? 'is-last' : undefined)}
//             direction={'row'}
//             justifyContent={'space-between'}
//           >
//             <Typography className={classes.greyText}>{item.text}</Typography>
//             <Stack direction={'row'} alignItems={'center'} gap={1}>
//               {item.isFulfilled ? <CheckCircleIcon className={cx(classes.icon, 'primary')} /> : <DoNotDisturbIcon className={classes.icon} />}
//               <Typography className={item.isFulfilled ? classes.primaryText : classes.greyText}>
//                 {item.isFulfilled ? 'fulfilled' : 'not fulfilled'}
//               </Typography>
//             </Stack>
//           </Stack>
//         ))}
//       </Stack>
//     </Stack>
//   );
// };

// interface AccordionProps {
//   title: string;
//   criteria: Criterion[];
//   defaultExpanded?: boolean;
// }

// const CriteriaAccordion: React.FC<AccordionProps> = ({ title, criteria, defaultExpanded }) => {
//   const { classes } = useStyles();

//   return (
//     <Accordion className={classes.accordion} elevation={0} defaultExpanded={defaultExpanded}>
//       <AccordionSummary className={classes.summary} expandIcon={<ExpandMoreIcon />}>
//         <Typography>{title}</Typography>
//       </AccordionSummary>
//       <AccordionDetails className={classes.details}>
//         <Stack>
//           {criteria.map((criterion, index) => (
//             <CriterionItem key={index} criterion={criterion} isLast={index === criteria.length - 1} />
//           ))}
//         </Stack>
//       </AccordionDetails>
//     </Accordion>
//   );
// };

interface Props {
  aiJudgementExplanation: string | undefined;
  fullName: string | undefined;
  assessment: Assessment | undefined;
  percentiles: ProfileValues | undefined;
  userProfile?: ProfileValues;

  qualificationToText(): string;
}

const AssessmentOverview: React.FC<Props> = ({ aiJudgementExplanation, fullName, assessment, percentiles, userProfile, qualificationToText }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const [selectedAnalysis, setSelectedAnalysis] = useState<AnalysisSelectionNew>(AnalysisSelectionNew.PERSONALITY_TYPE);

  const handleSelectedAnalysisChange = (newSelection: AnalysisSelectionNew) => {
    return () => {
      setSelectedAnalysis(newSelection);
    };
  };

  return (
    <>
      {!_.isNil(aiJudgementExplanation) ? (
        <>
          <Typography className={classes.boldText}>{t('qualificationReason')}</Typography>
          <div className={classes.infoContainer}>
            <div className={classes.infoContainerHeader}>
              <Stack direction={'row'} alignItems={'center'} gap={1}>
                <WorkIcon className={classes.icon} />
                <Typography className={classes.boldText}>{t('whyIsContactQualified', { fullName, qualification: qualificationToText() })}</Typography>
              </Stack>
            </div>
            <Stack className={classes.infoContainerContent} gap={1}>
              <div className={classes.greyText}>{aiJudgementExplanation || t('noExplanationYet')}</div>
            </Stack>
          </div>
        </>
      ) : null}

      {!_.isNil(assessment) ? (
        <Stack className={classes.personaContainer} gap={1}>
          <ContactPersona contactName={undefined} contactOccupation={undefined} assessment={assessment} />
          <AnalysisTabBar selectedAnalysis={selectedAnalysis} handleSelectedAnalysisChange={handleSelectedAnalysisChange} />
          <AnalysisTabContent
            contactName={fullName}
            selectedAnalysis={selectedAnalysis}
            contactAssessment={assessment}
            contactProfile={percentiles}
            userProfile={userProfile}
          />
        </Stack>
      ) : null}
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  boldText: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
  },
  greyText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
  },
  // primaryText: {
  //   fontSize: theme.typography.pxToRem(13),
  //   color: theme.palette.primary.main,
  // },
  // accordion: {
  //   border: `1px solid ${theme.palette.greys.light}`,
  //   borderRadius: '6px !important',
  //   overflow: 'hidden',
  //   '&::before': {
  //     display: 'none',
  //   },
  //   '&.Mui-expanded': {
  //     margin: 0,
  //   },
  // },
  // summary: {
  //   minHeight: 'unset !important',
  //   background: theme.palette.backgrounds.main_new,
  //   '& .MuiAccordionSummary-content': {
  //     margin: '6.5px 0',
  //   },
  //   '&.Mui-expanded': {
  //     background: theme.palette.backgrounds.main_new,
  //   },
  //   '& .MuiTypography-root': {
  //     fontSize: theme.typography.pxToRem(13),
  //     fontWeight: 'bold',
  //   },
  // },
  // details: {
  //   padding: 0,
  // },
  // criterionName: {
  //   width: '160px',
  //   padding: '8px 16px',
  //   borderRight: `1px solid ${theme.palette.greys.light}`,
  //   borderBottom: `1px solid ${theme.palette.greys.light}`,
  //   '&.is-last': {
  //     borderBottom: 'none',
  //   },
  // },
  // criterionValue: {
  //   padding: '8px 16px',
  //   borderBottom: `1px solid ${theme.palette.greys.light}`,
  //   '&.is-last': {
  //     borderBottom: 'none',
  //   },
  // },
  // icon: {
  //   fontSize: theme.typography.pxToRem(20),
  //   color: theme.palette.greys.medium,
  //   '&.primary': {
  //     color: theme.palette.primary.main,
  //   },
  // },
  infoContainer: {
    border: `1px solid ${theme.palette.greys.light}`,
    borderRadius: '8px',
  },
  infoContainerHeader: {
    padding: '8px 16px',
    borderBottom: `1px solid ${theme.palette.greys.light}`,
  },
  infoContainerContent: {
    padding: '8px 16px',
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
  },
  personaContainer: {
    padding: '8px',
    borderRadius: '8px',
    background: theme.palette.backgrounds.main_new,
  },
}));

export default AssessmentOverview;
